import React, { createContext, useContext } from 'react';

export const PageContext = createContext<React.RefObject<HTMLElement> | null>(
  null,
);

export const useHeaderRef = () => {
  const ref = useContext(PageContext);

  if (ref == null) {
    throw new Error(`useHeaderRef must be used inside <HeaderRefProvider />`);
  }

  return ref;
};
